import PostalCodeAutoComplete from "./PostalCodeAutoComplete";

export default PostalCodeAutoComplete;